export const addContextAndRoleTags  = (context, tags) => (envelope) => {
    envelope.tags["ai.application.ver"] = context.applicationVersion;
    envelope.tags["ai.operation.id"] = context.operationId;
    envelope.tags["ai.operation.parentId"] = context.operationId;
    envelope.tags["ai.operation.name"] = context.operationName;

    envelope.tags["ai.cloud.role"] = tags.cloudRole;
    envelope.tags["ai.cloud.roleInstance"] = tags.cloudRoleInstance;
};
